import { Icon } from "./Icon.tsx";

/** "Add Raingage" tool icon — RaingageIcon.tsx's own raindrop (scaled down to leave room), same "shape + plus badge" convention as AddJunctionIcon.tsx/AddConduitIcon.tsx/AddSubcatchmentIcon.tsx. */
export function AddRaingageIcon() {
  return (
    <Icon>
      <path d="M9 3c2.2 3.3 4.4 5.9 4.4 8.4a4.4 4.4 0 0 1-8.8 0C4.6 8.9 6.8 6.3 9 3Z" />
      <path d="M18 3v6M15 6h6" />
    </Icon>
  );
}
